document.addEventListener('DOMContentLoaded', function() {
  initAllSlideshows();
});

document.addEventListener('shopify:section:load', function(event) {
  var sectionContainer = event.target;
  var carousel = sectionContainer.querySelector('.custom-carousel-section');
  if (carousel) {
    initSlideshow(carousel);
  }
});

function initAllSlideshows() {
  var carousels = document.querySelectorAll('.custom-carousel-section');
  carousels.forEach(function(carousel) {
    initSlideshow(carousel);
  });
}

function initSlideshow(carousel) {
  var slides = carousel.querySelectorAll('.slideshow__slide');
  var prevBtn = carousel.querySelector('.slideshow__arrow--prev');
  var nextBtn = carousel.querySelector('.slideshow__arrow--next');
  var slideshow = carousel.querySelector('.slideshow');
  var isMobile = window.innerWidth < 769;

  if (slides.length === 0) return;

  // Initialize current index
  var currentIndex = 0;
  for (var i = 0; i < slides.length; i++) {
    if (slides[i].classList.contains('is-active')) {
      currentIndex = i;
      break;
    }
  }

  // Function to show a specific slide by index
  function showSlide(index) {
    // Ensure the index is valid and wrap around if needed
    if (index >= slides.length) {
      index = 0;
    } else if (index < 0) {
      index = slides.length - 1;
    }

    currentIndex = index;

    // For desktop view, manage active classes
    if (!isMobile) {
      // Remove active class from all slides
      slides.forEach(function(slide) {
        slide.classList.remove('is-active');
      });

      // Add active class to the current slide
      if (slides[currentIndex]) {
        slides[currentIndex].classList.add('is-active');
      }
    }

    // Update all dots
    updateDots(currentIndex);

    // For mobile, scroll to the current slide smoothly
    if (isMobile && slideshow) {
      const slideToScrollTo = slides[currentIndex];
      if (slideToScrollTo) {
        slideshow.scrollTo({
          left: slideToScrollTo.offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }

  // Function to update dot indicators
  function updateDots(index) {
    carousel.querySelectorAll('.slideshow__dot').forEach(function(dot) {
      if (parseInt(dot.dataset.index) === index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  // Attach event listeners to navigation controls
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      showSlide(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      showSlide(currentIndex + 1);
    });
  }

  // Attach click event listeners to all navigation dots
  carousel.querySelectorAll('.slideshow__dot').forEach(function(dot) {
    dot.addEventListener('click', function() {
      showSlide(parseInt(dot.dataset.index));
    });
  });

  // Mobile scroll detection
  if (isMobile && slideshow) {
    // Store previous scroll position to detect changes
    let lastScrollLeft = slideshow.scrollLeft;

    // Create an intersection observer to detect which slide is most visible
    const options = {
      root: slideshow,
      threshold: 0.5 // Trigger when at least 50% of the slide is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // When a slide becomes visible, update the dots
          const slideIndex = Array.from(slides).indexOf(entry.target);
          if (slideIndex !== currentIndex) {
            currentIndex = slideIndex;
            updateDots(currentIndex);
          }
        }
      });
    }, options);

    // Observe all slides
    slides.forEach(slide => {
      observer.observe(slide);
    });

    // Regular scroll listener as a fallback
    slideshow.addEventListener('scroll', function() {
      // Only process if scroll position actually changed
      if (slideshow.scrollLeft !== lastScrollLeft) {
        lastScrollLeft = slideshow.scrollLeft;

        // Find the most visible slide
        const slideWidth = slides[0].offsetWidth;
        const visibleIndex = Math.round(slideshow.scrollLeft / slideWidth);

        if (visibleIndex !== currentIndex && visibleIndex >= 0 && visibleIndex < slides.length) {
          currentIndex = visibleIndex;
          updateDots(currentIndex);
        }
      }
    });

    // Poll the scroll position regularly to catch any missed events
    let scrollInterval;

    function startScrollPolling() {
      if (scrollInterval) clearInterval(scrollInterval);

      scrollInterval = setInterval(() => {
        const slideWidth = slides[0].offsetWidth;
        const visibleIndex = Math.round(slideshow.scrollLeft / slideWidth);

        if (visibleIndex !== currentIndex && visibleIndex >= 0 && visibleIndex < slides.length) {
          currentIndex = visibleIndex;
          updateDots(currentIndex);
        }
      }, 200); // Check every 200ms
    }

    // Start polling when touch/scroll starts
    slideshow.addEventListener('touchstart', startScrollPolling);
    slideshow.addEventListener('scroll', startScrollPolling);

    // Stop polling when touch ends (after a delay)
    slideshow.addEventListener('touchend', () => {
      setTimeout(() => {
        if (scrollInterval) clearInterval(scrollInterval);
      }, 1000);
    });
  }

  // When the window resizes, check if we need to reinitialize
  window.addEventListener('resize', function() {
    const wasDesktop = !isMobile;
    isMobile = window.innerWidth < 769;

    // If we switched between mobile and desktop
    if (wasDesktop !== isMobile) {
      setTimeout(function() {
        showSlide(currentIndex);
      }, 100);
    }
  });

  // Initialize the first slide
  showSlide(currentIndex);
}
